import React, { useMemo } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Dropdown,
  DropdownButton,
  Form,
  Modal,
  Row,
  Spinner,
  Table,
  OverlayTrigger,
  Tooltip,
  Image
} from "react-bootstrap";
import { AccordionSummary, AccordionDetails, Accordion } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import refreshIcon from "../../assets/refresh.png";
import { FaUserCheck, FaUserTimes } from "react-icons/fa";
import { LuFileWarning } from "react-icons/lu";
import { MdOutlineDangerous } from "react-icons/md";
import { DateTime } from "luxon";
import { isValidValue } from "../../util/common";
import incompleteIcon from "../../assets/incomplete-icon.png";
import pendingIcon from "../../assets/pending-icon.png";
import rejectedIcon from "../../assets/rejected-icon.png";
import completedIcon from "../../assets/completed-icon.png";
import { BsFillArrowUpRightCircleFill } from "react-icons/bs";

const MainBookingDetails = ({
  refreshUserStatus,
  userTbdOnboardMessage,
  setSignupModal,
  bookingDetails,
  patientData,
  storePatientInfoUpdates,
  isUserReadOnlyMasterFlag,
  showyErrors,
  openPatientInfoUpdateModal,
  openIdentityDocsModal,
  openDocVerification
}) => {
  const appntStartLocal = useMemo(() => {
    let dt =
      bookingDetails?.appntStartEpochSec && bookingDetails?.appntStartEpochSec?.length > 0
        ? DateTime.fromMillis(bookingDetails.appntStartEpochSec * 1000)
        : DateTime.fromISO(bookingDetails?.appntStart);

    const tz = bookingDetails?.careLocation?.timezone;
    if (!isValidValue(tz)) {
      return dt.toFormat("LLL dd, yyyy hh:mm a");
    }

    const dateTimeInZone = dt.setZone(tz);
    return dateTimeInZone.toFormat("LLL dd, yyyy hh:mm a");
  }, [bookingDetails, bookingDetails?.appntStartEpochSec, bookingDetails?.appntStart, bookingDetails?.careLocation]);

  const isValidGovermentIssuedId = isValidValue(
    bookingDetails?.documentS3UrlMap?.IDENTITY_PASSPORT || bookingDetails?.documentS3UrlMap?.IDENTITY_DRIVER_LICENSE
  );
  const isValidSelfie = isValidValue(bookingDetails?.documentS3UrlMap?.SELFIE);

  const openJotform = () => {
    if (!bookingDetails?.patientIntakeJotformSubmissionLink) {
      return;
    }
    window.open(bookingDetails?.patientIntakeJotformSubmissionLink, "_blank");
  };

  return (
    <Accordion defaultExpanded className="mb-4 rounded-none">
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" style={{ background: "#0000000F" }}>
        <Card.Header className="w-100 border-0 bg-transparent ">
          <Row id="cardTitle" className="w-100">
            <Col md={4}>Appointment details &nbsp;</Col>
            <Col
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end"
              }}
            >
              <Row className="mr-1">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <span>Refresh for patient account status</span>
                  &nbsp;&nbsp;
                  <img
                    id="refreshIcon"
                    alt="refresh"
                    src={refreshIcon}
                    style={{
                      width: "2vw",
                      height: "2vw",
                      objectFit: "contain",
                      cursor: "pointer",
                      transitionDuration: "1s",
                      marginLeft: 10
                    }}
                    onClick={e => {
                      e.stopPropagation();
                      refreshUserStatus();
                    }}
                  />
                  {/*has account*/}
                  {userTbdOnboardMessage.hasAcc && (
                    <>
                      <span
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "center",
                          marginLeft: 10,
                          color: userTbdOnboardMessage.isError ? "red" : userTbdOnboardMessage.isWarning ? "orange" : "green"
                        }}
                      >
                        {userTbdOnboardMessage.isError ? <MdOutlineDangerous size={25} /> : <FaUserCheck size={25} />}&nbsp;{" "}
                        <p
                          style={{ margin: 0, cursor: "pointer" }}
                          onClick={e => {
                            e.stopPropagation();
                            window.open(`/PatientProfile?patientId=${patientData?.userId}&idType=sub`, "_blank");
                          }}
                        >
                          {userTbdOnboardMessage.message} <BsFillArrowUpRightCircleFill style={{ color: "green", marginLeft: "5px" }} />
                        </p>
                      </span>
                    </>
                  )}
                  {/*no account*/}
                  {!userTbdOnboardMessage?.hasAcc && (
                    <>
                      <Button
                        className="ml-3"
                        variant="light"
                        style={{
                          width: "auto",
                          color: "white",
                          background: "#866BD9",
                          height: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center"
                        }}
                        onClick={() => setSignupModal(true)}
                      >
                        <FaUserTimes />
                        <span id="btn-text">Send Signup Link</span>
                      </Button>
                      <span
                        style={{
                          marginLeft: 10,
                          color: userTbdOnboardMessage.isError ? "red" : userTbdOnboardMessage.isWarning ? "yellow" : "green"
                        }}
                      >
                        {userTbdOnboardMessage.isError ? <MdOutlineDangerous size={25} /> : <FaUserCheck size={25} />}&nbsp;{" "}
                        {userTbdOnboardMessage.message}
                      </span>
                    </>
                  )}
                </div>
              </Row>
            </Col>
          </Row>
        </Card.Header>
      </AccordionSummary>
      <AccordionDetails>
        <Row className="w-100">
          <Col style={{ flex: 1.5 }}>
            <Card className="Card-wrap border-0 shadow-none">
              <Card.Body>
                {/* row1 */}
                <Row className="mb-3" align="start">
                  <Col>
                    <Form.Group as={Row} controlId="formBookingId">
                      <Form.Label id="cardFormLabel" column sm={4}>
                        Booking id
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          placeholder="Booking id"
                          aria-label="Booking id"
                          aria-describedby="basic-addon1"
                          value={bookingDetails?.id}
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Row} controlId="formLocation">
                      <Form.Label id="cardFormLabel" column sm={4}>
                        City
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          placeholder="City"
                          aria-label="City"
                          aria-describedby="basic-addon1"
                          defaultValue={bookingDetails?.city ? bookingDetails?.city : patientData?.address?.locality}
                          onChange={e => storePatientInfoUpdates("city", e.target.value)}
                          readOnly={isUserReadOnlyMasterFlag}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* row1 */}
                <Row className="mb-3" align="start">
                  <Col>
                    <Form.Group as={Row} controlId="formBookingId">
                      <Form.Label id="cardFormLabel" column sm={4}>
                        Service Type
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          placeholder="Care Type"
                          aria-label="Care Type"
                          aria-describedby="basic-addon1"
                          value={bookingDetails?.careType?.displayName ?? "UNKNOWN"}
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Row} controlId="formLocation">
                      <Form.Label id="cardFormLabel" column sm={4}>
                        Service Location
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          placeholder="Service Location"
                          aria-label="Service Location"
                          aria-describedby="basic-addon1"
                          defaultValue={`${bookingDetails?.careLocation?.address}`}
                          value={`${bookingDetails?.careLocation?.address}`}
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3" align="start">
                  <Col>
                    <Form.Group as={Row} controlId="formBookingId">
                      <Form.Label id="cardFormLabel" column sm={4}>
                        Service State
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          placeholder="State"
                          aria-label="State"
                          aria-describedby="basic-addon1"
                          defaultValue={bookingDetails?.careStateRegion}
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Row} controlId="formLocation">
                      <Form.Label id="cardFormLabel" column sm={4}>
                        Address Line 1
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          placeholder="Address Line 1"
                          aria-label="Address Line 1"
                          aria-describedby="basic-addon1"
                          defaultValue={bookingDetails?.address1 ? bookingDetails?.address1 : patientData?.address?.street_address}
                          onChange={e => storePatientInfoUpdates("address1", e.target.value)}
                          readOnly={isUserReadOnlyMasterFlag}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* row2 */}
                <Row className="mb-3" align="start">
                  <Col>
                    <Form.Group as={Row} controlId="formEmail">
                      <Form.Label id="cardFormLabel" column sm={4}>
                        Email
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          placeholder="Email"
                          aria-label="Email"
                          aria-describedby="basic-addon1"
                          defaultValue={bookingDetails?.email}
                          onChange={e => storePatientInfoUpdates("email", e.target.value)}
                          // readOnly={isUserReadOnlyMasterFlag}
                          readOnly={true}
                        />
                        {showyErrors?.email && <Form.Text style={{ color: "red" }}>{showyErrors?.email}</Form.Text>}
                        {showyErrors?.updateReason && <Form.Text style={{ color: "red" }}>{showyErrors?.updateReason}</Form.Text>}
                      </Col>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Row} controlId="formAddress">
                      <Form.Label id="cardFormLabel" column sm={4}>
                        Address Line 2
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          placeholder="Address Line 2"
                          aria-label="Address Line 2"
                          aria-describedby="basic-addon1"
                          defaultValue={bookingDetails?.address2 ? bookingDetails?.address2 : patientData?.address?.street_address2}
                          onChange={e => storePatientInfoUpdates("address2", e.target.value)}
                          readOnly={isUserReadOnlyMasterFlag}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* row3 */}
                <Row className="mb-3" align="start">
                  <Col>
                    <Form.Group as={Row} controlId="formFirstName">
                      <Form.Label id="cardFormLabel" column sm={4}>
                        First name
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          placeholder="First name"
                          aria-label="First name"
                          aria-describedby="basic-addon1"
                          defaultValue={bookingDetails?.firstName}
                          onChange={e => storePatientInfoUpdates("firstName", e.target.value)}
                          readOnly={isUserReadOnlyMasterFlag}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Row} controlId="formLastName">
                      <Form.Label id="cardFormLabel" column sm={4}>
                        Last name
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          placeholder="Last name"
                          aria-label="Last name"
                          aria-describedby="basic-addon1"
                          defaultValue={bookingDetails?.lastName}
                          onChange={e => storePatientInfoUpdates("lastName", e.target.value)}
                          readOnly={isUserReadOnlyMasterFlag}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* row4 */}
                <Row className="mb-3" align="start">
                  <Col>
                    <Form.Group as={Row} controlId="formCreatedDateTime">
                      <Form.Label id="cardFormLabel" column sm={4}>
                        Booked at
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          placeholder="Booked DateTime"
                          aria-label="Booked DateTime"
                          aria-describedby="basic-addon1"
                          value={DateTime.fromISO(bookingDetails?.bookedAt).toFormat("LL-dd-yyyy hh:mm a") ?? "unknown"}
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Row} controlId="formPhone">
                      <Form.Label id="cardFormLabel" column sm={4}>
                        Phone
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          placeholder="Phone"
                          aria-label="Phone"
                          aria-describedby="basic-addon1"
                          defaultValue={bookingDetails?.phone}
                          onChange={e => storePatientInfoUpdates("phone", e.target.value)}
                          readOnly={isUserReadOnlyMasterFlag}
                        />
                        {showyErrors?.phone && <Form.Text style={{ color: "red" }}>{showyErrors?.phone}</Form.Text>}
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* row5 */}
                <Row className="mb-3" align="start">
                  <Col>
                    <Form.Group as={Row} controlId="formAppointmentDateTime">
                      <Form.Label id="cardFormLabel" column sm={4}>
                        Appointment on <span style={{ fontSize: "10px" }}>({bookingDetails?.eventTimeZone || ""})</span>
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          placeholder="Appointment DateTime"
                          aria-label="Appointment DateTime"
                          aria-describedby="basic-addon1"
                          value={appntStartLocal}
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Row} controlId="formAppointmentMobile">
                      <Form.Label id="cardFormLabel" column sm={4}>
                        Mobile
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          placeholder="Mobile"
                          aria-label="Mobile"
                          aria-describedby="basic-addon1"
                          defaultValue={bookingDetails?.phone}
                          onChange={e => storePatientInfoUpdates("mobile", e.target.value)}
                          readOnly={isUserReadOnlyMasterFlag}
                        />
                        {showyErrors?.mobile && <Form.Text style={{ color: "red" }}>{showyErrors?.mobile}</Form.Text>}
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                {/*date of birth & sex at birth*/}
                <Row className="mb-3" align="start">
                  <Col>
                    <Form.Group as={Row} controlId="dobb">
                      <Form.Label id="cardFormLabel" column sm={4}>
                        Date of Birth
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          placeholder="Date of Birth"
                          aria-label="Date of Birth"
                          aria-describedby="basic-addon1"
                          type="date"
                          defaultValue={bookingDetails?.dob ? bookingDetails?.dob : patientData?.dob}
                          onChange={e => storePatientInfoUpdates("dob", e.target.value)}
                          readOnly={isUserReadOnlyMasterFlag}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Row} controlId="med">
                      <Form.Label id="cardFormLabel" column sm={4}>
                        Sex at Birth
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          placeholder=""
                          aria-label="Sex at Birth"
                          aria-describedby="basic-addon1"
                          defaultValue={
                            bookingDetails?.genderAtBirth
                              ? bookingDetails?.genderAtBirth
                              : patientData?.genderAtBirth
                              ? patientData?.genderAtBirth
                              : "UNKNOWN"
                          }
                          value={
                            bookingDetails?.genderAtBirth
                              ? bookingDetails?.genderAtBirth
                              : patientData?.genderAtBirth
                              ? patientData?.genderAtBirth
                              : "UNKNOWN"
                          }
                          readOnly={true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                {/*Medications & Allergies*/}
                <Row className="mb-3" align="start">
                  <Col>
                    <Form.Group as={Row} controlId="dobb">
                      <Form.Label id="cardFormLabel" column sm={4}>
                        Medications
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          placeholder=""
                          aria-label="Medications"
                          as="textarea"
                          rows={3}
                          aria-describedby="basic-addon1"
                          defaultValue={bookingDetails?.medications || "unknown"}
                          onChange={e => storePatientInfoUpdates("medications", e.target.value)}
                          readOnly={false}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Row} controlId="med">
                      <Form.Label id="cardFormLabel" column sm={4}>
                        Allergies
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          placeholder=""
                          aria-label="Allergies"
                          as="textarea"
                          rows={3}
                          aria-describedby="basic-addon1"
                          defaultValue={patientData?.allergies || "NONE"}
                          onChange={e => storePatientInfoUpdates("allergies", e.target.value)}
                          readOnly={false}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                {/*Symptoms & verification*/}
                <Row className="mb-3" align="start">
                  <Col>
                    <Form.Group as={Row} controlId="symptoms">
                      <Form.Label id="cardFormLabel" column sm={4}>
                        Symptoms
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          placeholder="Symptoms"
                          aria-label="Symptoms"
                          as="textarea"
                          rows={3}
                          aria-describedby="basic-addon1"
                          defaultValue={bookingDetails?.symptoms || "Symptoms"}
                          onChange={e => storePatientInfoUpdates("symptoms", e.target.value)}
                          readOnly={false}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col>
                    <Form.Group as={Row} controlId="dobb">
                      <Form.Label id="cardFormLabel" column sm={4}>
                        Preferred Pronouns
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          placeholder="Preferred pronouns"
                          aria-label="Preferred pronouns"
                          aria-describedby="basic-addon1"
                          type="text"
                          defaultValue={bookingDetails?.pronoun || "NA"}
                          value={bookingDetails?.pronoun || "NA"}
                          onChange={e => storePatientInfoUpdates("pronoun", e.target.value)}
                          readOnly={true || isUserReadOnlyMasterFlag}
                        />
                      </Col>
                    </Form.Group>
                    {bookingDetails?.patientIntakeJotformSubmissionLink && (
                      <Form.Group as={Row} controlId="symptoms">
                        <Form.Label id="cardFormLabel" column sm={4}>
                          Patient in-take form
                        </Form.Label>
                        <Col onClick={openJotform} sm={8} style={{ color: "#EF8156", textDecoration: "underline", cursor: "pointer" }}>
                          Open in new window &nbsp; <BsFillArrowUpRightCircleFill />
                        </Col>
                      </Form.Group>
                    )}
                  </Col>
                </Row>

                {/*Symptoms & verification*/}
                <Row className="mb-3" align="start">
                  <Col>
                    <Form.Group as={Row} controlId="symptoms">
                      <Form.Label id="cardFormLabel" column sm={4}>
                        Patient documents
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Group as={Row} controlId="formLastName">
                          <Col sm={8}>
                            <Form.Label id="cardFormLabel" column style={{ paddingLeft: 0, paddingRight: 0 }}>
                              {isValidGovermentIssuedId && isValidSelfie ? (
                                <span>
                                  {bookingDetails?.isSelfCheckInIdentityVerified === undefined ||
                                  bookingDetails?.isSelfCheckInIdentityVerified === null
                                    ? "Verification pending"
                                    : bookingDetails?.isSelfCheckInIdentityVerified
                                    ? "Verified"
                                    : "Rejected"}
                                  <span>
                                    <Image
                                      style={{ marginLeft: "10px" }}
                                      src={
                                        bookingDetails?.isSelfCheckInIdentityVerified === undefined ||
                                        bookingDetails?.isSelfCheckInIdentityVerified === null
                                          ? pendingIcon
                                          : bookingDetails?.isSelfCheckInIdentityVerified
                                          ? completedIcon
                                          : rejectedIcon
                                      }
                                    />
                                  </span>
                                  <span
                                    onClick={openDocVerification}
                                    style={{ fontWeight: "600", color: "#007F61", marginLeft: 20, cursor: "pointer" }}
                                  >
                                    {bookingDetails?.isSelfCheckInIdentityVerified === undefined ||
                                    bookingDetails?.isSelfCheckInIdentityVerified === null
                                      ? "Verify"
                                      : "View"}
                                  </span>
                                </span>
                              ) : !isValidGovermentIssuedId && !isValidSelfie ? (
                                <span>No identity docs available</span>
                              ) : (
                                <span>
                                  Incomplete
                                  <Image style={{ marginLeft: "10px" }} src={incompleteIcon} />
                                </span>
                              )}
                            </Form.Label>
                          </Col>
                        </Form.Group>
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col>
                    <Form.Group as={Row} controlId="dobb">
                      <Form.Label id="cardFormLabel" column sm={4}>
                        Returning Patient
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          placeholder="Returning Patient"
                          aria-label="Returning Patient"
                          aria-describedby="basic-addon1"
                          type="text"
                          defaultValue={bookingDetails?.isReturningPatient ? "Yes" : "No"}
                          value={bookingDetails?.isReturningPatient ? "Yes" : "No"}
                          readOnly={true || isUserReadOnlyMasterFlag}
                        />
                      </Col>
                    </Form.Group>
                    {bookingDetails?.patientIntakeJotformSubmissionLink && (
                      <Form.Group as={Row} controlId="symptoms">
                        <Form.Label id="cardFormLabel" column sm={4}>
                          Patient in-take form
                        </Form.Label>
                        <Col onClick={openJotform} sm={8} style={{ color: "#EF8156", textDecoration: "underline", cursor: "pointer" }}>
                          Open in new window &nbsp; <BsFillArrowUpRightCircleFill />
                        </Col>
                      </Form.Group>
                    )}
                  </Col>
                </Row>

                <Row className="mb-3" align="start">
                  <Col>
                    <Form.Group as={Row} controlId="formLastName">
                      <Form.Label id="cardFormLabel" column sm={2}>
                        Customer booking notes
                      </Form.Label>
                      <Col sm={10}>
                        <Form.Control
                          placeholder="Customer booking notes"
                          aria-label="CustomerBookingNotes"
                          as="textarea"
                          rows={3}
                          aria-describedby="basic-addon1"
                          defaultValue={bookingDetails?.customerNotes || "NONE"}
                          value={bookingDetails?.customerNotes || "NONE"}
                          readOnly={true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                  {/*<Col>*/}
                  {/*  <Form.Group as={Row} controlId="formLastName">*/}
                  {/*    <Form.Label id="cardFormLabel" column sm={4}>*/}
                  {/*    Patient documents*/}
                  {/*    </Form.Label>*/}
                  {/*    <Col sm={8}>*/}
                  {/*    <Form.Label id="cardFormLabel" column>*/}
                  {/*    Verification pending <span onClick={openDocVerification} style={{ fontWeight: "600", color: "#007F61", marginLeft: 20, cursor: "pointer" }}>Verify</span>*/}
                  {/*    </Form.Label>*/}
                  {/*    </Col>*/}
                  {/*  </Form.Group>*/}
                  {/*</Col>*/}
                  {/* <Col>
                  <Form.Group as={Row} controlId="formLastName">
                      <Form.Label id="cardFormLabel" column sm={4}>
                        Patient documents
                      </Form.Label>
                      <Row>
                      <Form.Label id="cardFormLabel" column>
                        Verification pending <span style={{ fontWeight: "600", color: "#007F61", marginLeft: 30 }}>Verify</span>
                      </Form.Label>
                      </Row>
                    </Form.Group>
                  </Col> */}
                </Row>
                <hr />
                <Row style={{ justifyContent: "center", alignItems: "center" }}>
                  <Col md={4}>
                    <Button variant="light" style={{ color: "white", background: "#866BD9" }} onClick={openPatientInfoUpdateModal}>
                      <span id="btn-text">Update Patient Details</span>
                    </Button>
                  </Col>
                  <Col md={4}>
                    <Button
                      variant="success"
                      style={{ color: "white" }}
                      onClick={() => {
                        window.open(`/PatientProfile?patientId=${patientData?.userId}&idType=sub`, "_blank");
                      }}
                    >
                      <span id="btn-text">View Patient Profile</span>
                    </Button>
                  </Col>
                  <Col md={4}>
                    <Button variant="light" style={{ color: "white", background: "#866BD9" }} onClick={openIdentityDocsModal}>
                      <span id="btn-text">Manage Patient Identity Docs</span>
                    </Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </AccordionDetails>
    </Accordion>
  );
};

export default MainBookingDetails;
